import angular from 'angular';
import DynamicBannerComponent from './dynamic-banner.component';

let DynamicBannerModule = angular.module('shared.components.banners.dynamicBanner', [])
  .component('dynamicBanner', DynamicBannerComponent);

export default DynamicBannerModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/components/banners/dynamic-banner/dynamic-banner.js
 **/